import customEventBus from '../libs/eventBus';
const analyticsUtils = {
    listenForPush: () => {
        customEventBus.on('datalayer:push', (data) => {
            window.dataLayer.push(data);
        });
    },
    pushCheckoutStepDatalayer: async (step) => {
        let forcedPipeline = '';
        switch (step) {
            case 'shipping':
                forcedPipeline = 'CheckoutStepShipping';
                break;
            case 'payment':
                forcedPipeline = 'CheckoutStepPayment';
                break;
            default:
        }
        let formData = new FormData();
        formData.append('forcedPipeline', forcedPipeline);
        await fetch(window.asyncServiceUrl, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
        }).then(r => r.json()).then((data) => {
            if (data.dataLayer) {
                for (let i in data.dataLayer) {
                    window.dataLayer.push(data.dataLayer[i]);
                }
            }
        });
    },
    pushCheckoutSelectDatalayer: async (step, option) => {
        let stepNumber = '0';
        switch (step) {
            case 'shipping':
                stepNumber = '1';
                break;
            case 'payment':
                stepNumber = '2';
                break;
            default:
        }
        if (step === 'payment') {
            switch (option) {
                case 'scheme':
                    option = 'credit_card';
                    break;
                default:
            }
        }
        let formData = new FormData();
        formData.append('forcedPipeline', 'CheckoutSelectOption');
        formData.append('step', stepNumber);
        formData.append('option', option);
        await fetch(window.asyncServiceUrl, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
        }).then(r => r.json()).then((data) => {
            if (data.dataLayer) {
                for (let i in data.dataLayer) {
                    window.dataLayer.push(data.dataLayer[i]);
                }
            }
        });
    },
    getItemListId(tile) {
        let itemListId = 'card_prodotti';
        let carouselWrapper = tile.closest('.productcarouseleinstein.editorialcaroousel');
        if (carouselWrapper) {
            itemListId = 'carousel_1';
        }
        else if (tile.closest('.product-detail')) {
            itemListId = 'banner';
        }
        return itemListId;
    },
    getItemListName(tile) {
        let itemListName = 'Listing Page';
        let carouselWrapper = tile.closest('.productcarouseleinstein.editorialcaroousel');
        if (carouselWrapper) {
            let titleElement = carouselWrapper.querySelector('.productcarouseleinstein-header .title');
            if (titleElement) {
                itemListName = titleElement.textContent;
            }
        }
        else if (tile.closest('.wishlist-content')) {
            let wishlistContent = tile.closest('.wishlist-content');
            if (wishlistContent) {
                itemListName = "Wishlist";
            }
        }
        else if (tile.closest('.product-detail')) {
            itemListName = 'PDP';
        }
        return itemListName;
    },
    updateDataLayer(el, data) {
        if (data.dataLayer) {
            const page = document.querySelector('.page');
            let tileIndex = 0;
            const itemListId = this.getItemListId(el);
            const itemListName = this.getItemListName(el);
            if (itemListName === 'Listing Page' || itemListName === 'Wishlist') {
                tileIndex = this.getTileIndex(el.closest('.product-tile'));
            }
            else if (itemListId === 'carousel_1') {
                const productTile = el.closest('.experience-component.experience-molecules-productTile.swiper-slide');
                tileIndex = this.getTileIndexFromCarousel(productTile);
            }
            for (let i in data.dataLayer) {
                // @ts-ignore
                if (page && data.dataLayer[i].ecommerce && data.dataLayer[i].ecommerce.items && data.dataLayer[i].ecommerce.items.length > 0) {
                    data.dataLayer[i].ecommerce.items[0].item_list_name = itemListName;
                    data.dataLayer[i].ecommerce.items[0].item_list_id = itemListId;
                    data.dataLayer[i].ecommerce.items[0].index = tileIndex;
                    data.dataLayer[i].ecommerce.item_list_name = itemListName;
                    data.dataLayer[i].ecommerce.item_list_id = itemListId;
                }
                window.dataLayer.push(data.dataLayer[i]);
            }
        }
    },
    /* Get tiles info in listing */
    getTileListName(tile) {
        // name types: category, search, recommended, featured
        let listName = '';
        if (tile.closest('.editorial-component') !== null) {
            listName = 'featured';
        }
        else if (document.body.querySelector('[data-listingtype]') && document.body.querySelector('[data-listingtype]').getAttribute('data-listingtype') !== '') {
            listName = document.body.querySelector('[data-listingtype]').getAttribute('data-listingtype');
        }
        else if ('RECOMMENDED_TBD' === listName) {
            // TODO: definizione recommended
            listName = 'recommended';
        }
        return listName;
    },
    getTileListId(tile) {
        let listId = '';
        if (tile.closest('.editorial-component') !== null) {
            listId = tile.closest('.editorial-component').classList[1] || 'editorial-component';
        }
        else if (document.body.querySelector('[data-listingid]') && document.body.querySelector('[data-listingid]').getAttribute('data-listingid') !== '') {
            listId = document.body.querySelector('[data-listingid]').getAttribute('data-listingid');
        }
        else if ('RECOMMENDED_ID_TBD' === listId) {
            // TODO: definizione recommended
            listId = 'recommended';
        }
        return listId;
    },
    getTileIndex(tile) {
        let i = 0;
        let context = tile.parentNode;
        i = [...context.querySelectorAll('.product-tile')].indexOf(tile);
        return i;
    },
    getTileIndexFromCarousel(productTile) {
        let carouselWrapper = productTile.closest('.productcarouseleinstein.editorialcaroousel');
        var allProductTiles = carouselWrapper.querySelectorAll('.experience-component.experience-molecules-productTile.swiper-slide');
        return Array.prototype.indexOf.call(allProductTiles, productTile);
    },
    getListPids(context) {
        let productIds = [];
        if (context.querySelectorAll('.product-tile').length > 0) {
            context.querySelectorAll('.product-tile').forEach((item) => {
                productIds.push(item.getAttribute('data-productid'));
            });
        }
        return productIds;
    },
    async passThroughProcessor(data, _callback = null) {
        let formData = new FormData();
        for (let k in data) {
            formData.append(k, data[k]);
        }
        await fetch(window.asyncServiceUrl, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
        })
            .then((r) => r.json())
            .then((d) => {
            if (d.dataLayer && window.dataLayer) {
                for (let i in d.dataLayer) {
                    window.dataLayer.push(d.dataLayer[i]);
                }
            }
        })
            .catch((err) => {
            console.error(err);
        })
            .finally(() => {
            if (_callback) {
                _callback();
            }
        });
    }
};
export default analyticsUtils;
